(ns admin.components.composite.plo-uploader
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]

   [admin.events.activities :as >activities]

   [kyber.components.base.text :as text]
   [kyber.components.base.button :as button]
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.utils :as ku]
   [kyber.lib.kyber-db :as kyber-db]

   [admin.components.composite.resource-selector :as resource-selector]
   [admin.components.composite.resource-uploader :as resource-uploader]))

(def classes
  (styles->classes
   {:container
    {:margin :auto
     :margin-bottom (gs [:spacing :p40])
     :margin-top (gs [:spacing :p20])}

    :selection-container
    {:display :flex
     :align-items :center
     :justify-content :center

     "& > *"
     {:margin-right (gs [:spacing :p8])

      "&:last-child"
      {:margin-right (gs [:spacing :p0])}}}}))

(defn render
  [{:keys [force-stage] :or {force-stage nil}}]
  (let [upload-choice (reagent/atom force-stage)
        upload-plo-message "Upload your Primary Learning Object"
        select-plo-message "Select your Primary Learning Object"
        default-plo-message "Add your Primary Learning Object"
        file-selected (reagent/atom false)]
    (fn [{:keys [activity
                 curriculum
                 add-plo-message
                 set-plo-message
                 on-success
                 on-update-cancel
                 on-upload-start
                 activity-resources
                 margins
                 padding
                 width]
          :or {on-success identity
               on-update-cancel identity
               margins true}}]
      (let [{:activity/keys [plo-type]} activity
            plo-label (ku/plo->label plo-type)]
        ^{:key activity}
        [:div (cond-> {}
                (true? margins)
                (assoc :class (:container classes))

                (true? padding)
                (assoc-in [:style :padding] (gs [:spacing :p40]))

                (= @upload-choice :existing-resource)
                (assoc-in [:style :overflow-y] :scroll)

                (seq width)
                (assoc-in [:style :width] width))
         (case @upload-choice
           :new-resource
           (let [{request-abort :abort
                  request-status :status}
                 @(re-frame/subscribe
                   [:request/track-request
                    :resources/upload-resource-to-s3])

                 reset-plo
                 #(re-frame/dispatch
                   [::>activities/reset-primary-learning-object
                    (select-keys activity [:activity/uuid
                                           :activity/primary-learning-object])])]
             [:div
              [resource-uploader/render
               (cond-> {:curriculum-uuid (:curriculum/uuid curriculum)
                        :activity-uuid (:activity/uuid activity)
                        :is-plo-upload? true
                        :show-custom-version-id? (boolean (:curriculum/compliance-enabled curriculum))
                        :accepted-file-types (condp = plo-type
                                               "video" #{:video}
                                               "pdf" #{:file})
                        :on-file-selected #(reset! file-selected true)
                        :on-cancel #(reset! file-selected false)
                        :on-success #(do
                                       (on-success)
                                       (re-frame/dispatch
                                        [:dispatch-in 8000
                                         :activities/get-activity-overview
                                         {:activity-uuid (:activity/uuid activity)
                                          :curriculum-uuid (:curriculum/uuid curriculum)
                                          :poll-plo-score? true}]))}
                 (fn? on-upload-start)
                 (assoc :on-upload-start on-upload-start))]

              (let [is-uploading (and @file-selected (= :loading request-status))
                    no-file-selected (not @file-selected)]
                (when (or is-uploading
                          no-file-selected)
                  [button/button-link
                   {:on-click #(do (when (and is-uploading
                                              (fn? request-abort))
                                     (request-abort))
                                   (reset! upload-choice nil)
                                   (when (some? add-plo-message)
                                     (set-plo-message default-plo-message))
                                   (on-update-cancel)
                                   (reset-plo))
                    :style {:margin-top (gs [:spacing :p20])}}
                   (str "Cancel"
                        (when is-uploading " upload"))]))])

           :existing-resource
           [:div
            [resource-selector/render
             {:on-select (fn [{resource-uuid :resource/uuid} custom-version-id]
                           (if (not (contains? (->> activity-resources
                                                    (map :resource/uuid)
                                                    (set))
                                               resource-uuid))
                             (js/console.error "Selected resource not linked to activity")
                             ;; Always create PLO version, optionally with custom-version-id
                             (re-frame/dispatch
                              [::>activities/create-plo-version-and-update-activity
                               (cond-> {:activity/uuid (:activity/uuid activity)
                                        :resource/uuid resource-uuid}
                                 (seq custom-version-id)
                                 (assoc :plo-version/custom-version-id custom-version-id))
                               {:response-keys [:activity/uuid
                                                {:activity/primary-learning-object
                                                 (kyber-db/get-model-keys :resource)}
                                                {:activity/resources
                                                 (conj (kyber-db/get-model-keys :resource)
                                                       :activity/uuid)}]
                                :on-success (fn [_response]
                                               (on-success)
                                               (re-frame/dispatch
                                                [:dispatch-in 8000
                                                 :activities/get-activity-overview
                                                 {:activity-uuid (:activity/uuid activity)
                                                  :curriculum-uuid (:curriculum/uuid curriculum)
                                                  :poll-plo-score? true}]))}])))
              :resources activity-resources
              :accepted-file-types (condp = plo-type
                                     "video" #{:video}
                                     "pdf" #{:pdf})
              :show-custom-version-id? (boolean (:curriculum/compliance-enabled curriculum))}]

            [button/button-link
             {:on-click #(do (reset! upload-choice nil)
                             (when (some? add-plo-message)
                               (set-plo-message default-plo-message))
                             (on-update-cancel))
              :style {:margin-top (gs [:spacing :p20])}}
             "Cancel"]]

           [:div {:class (:selection-container classes)}
            [button/primary-button
             {:on-click #(do
                           (reset! upload-choice :new-resource)
                           (when (some? add-plo-message)
                             (set-plo-message upload-plo-message)))}
             (str "Upload new " plo-label)]

            [text/caption-30 :p "or"]

            [button/secondary-button
             {:on-click #(do
                           (reset! upload-choice :existing-resource)
                           (when (some? add-plo-message)
                             (set-plo-message select-plo-message)))}
             (str "Select existing " plo-label)]])]))))
